module.exports = __webpack_public_path__ + "img/study-mode-faq-4.e3e3135b.png";